import IApiResponse from "../../interfaces/IApiResponse";
import SQLiteDB from "../../data/SQLiteDB";
import SuccessApiResponse from "../../data/SuccessApiResponse";
import IDismissibleMessage from "../../interfaces/IDismissibleMessage";
import {IDismissibleMessageService} from  "../DismissibleMessageService";
import SQLiteHelperService from "../SQLiteHelperService";
import { SQLiteTables } from "../../data/SQLiteTables";
import ISQLiteResponse from "../../interfaces/ISQLiteResponse";

const dbFailedResponse = Promise.resolve({
    Data: undefined,
    Success: false,
    Message: { UserMessage: 'db not connected', ServerMessage: 'db not connected' }});

    
const DismissibleMessageServiceHybrid: IDismissibleMessageService = {
    
    logDismissibleMessage: async (dismissibleMessage) => {
        const messageQuery = SQLiteHelperService.insertQuery(SQLiteTables.dismissibleMessages, dismissibleMessage);
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IDismissibleMessage>> = db.executeSql(messageQuery, []).then((dbResult: ISQLiteResponse<IDismissibleMessage>)=>{
                dismissibleMessage.id = dbResult.insertId.toString();
                const response = {...SuccessApiResponse, Data: dismissibleMessage};
                response.Message.UserMessage = 'SUCCESS: ADDED NEW Dismissible Message.';
                console.log(response);
                return response;
            }).catch((error)=>{
                const response = {
                    Data: dismissibleMessage,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                console.log(response);
                return response as IApiResponse<IDismissibleMessage>;
            });
            return dbResponse;
        } else {
            console.error('db not connected');
            return dbFailedResponse;
        }
    },

    getDismissibleMessages: async (category: string) =>  {
        const messageQuery = `SELECT * FROM ${SQLiteTables.dismissibleMessages} WHERE \`category\`='${category}'`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IDismissibleMessage[]>> = db.executeSql(messageQuery, []).then((dbResult: ISQLiteResponse<IDismissibleMessage>)=>{
                if(dbResult.rows.length) {
                    const dbApiResponse = {...SuccessApiResponse, Data: SQLiteHelperService.queryResultToArray(dbResult, true) as IDismissibleMessage[]};
                    console.log(dbApiResponse)
                    return  dbApiResponse;
                } else {
                    return {
                        Data: [],
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND Dismissible Message', ServerMessage: 'FAILED TO GET' }
                    }
                }
            }).catch((error)=>{
                const response = {
                    Data: [],
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                return response;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    getAllDismissibleMessages: async () =>  {
        const messageQuery = `SELECT * FROM ${SQLiteTables.dismissibleMessages}`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IDismissibleMessage[]>> = db.executeSql(messageQuery, []).then((dbResult: ISQLiteResponse<IDismissibleMessage>)=>{
                if(dbResult.rows.length) {
                    const dbApiResponse = {...SuccessApiResponse, Data: SQLiteHelperService.queryResultToArray(dbResult, true) as IDismissibleMessage[]};
                    console.log(dbApiResponse)
                    return  dbApiResponse;
                } else {
                    return {
                        Data: [],
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND Dismissible Message', ServerMessage: 'FAILED TO GET' }
                    }
                }
            }).catch((error)=>{
                const response = {
                    Data: [],
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                return response;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },

    getDismissibleMessage: async (messageId: string) =>  {
        const messageQuery = `SELECT * FROM ${SQLiteTables.dismissibleMessages} WHERE \`messageId\`='${messageId}'`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IDismissibleMessage>> = db.executeSql(messageQuery, []).then((dbResult:ISQLiteResponse<IDismissibleMessage>)=>{
                if(dbResult.rows.length) {
                    const dbApiResponse = {...SuccessApiResponse, Data: SQLiteHelperService.convertToJsTypes(dbResult.rows.item(0))};
                    console.log(dbApiResponse)
                    return  dbApiResponse;
                } else {
                    return {
                        Data: undefined,
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND Dismissible Message', ServerMessage: 'FAILED TO GET' }
                    }
                }
            }).catch((error)=>{
                const response = {
                    Data: undefined,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                return response as IApiResponse<IDismissibleMessage>;
            });

            return dbResponse;
        } else {
            console.error('db not connected');
            return dbFailedResponse;
        }
    },

    updateDismissibleMessage: async (dismissibleMessage) => {
        const messageQuery = SQLiteHelperService.replaceQuery(SQLiteTables.dismissibleMessages, dismissibleMessage);
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IDismissibleMessage>> = db.executeSql(messageQuery, []).then((result)=>{
                    const response = {...SuccessApiResponse, Data: dismissibleMessage};
                    response.Message.UserMessage = 'SUCCESS: UPDATED Dismissible Message.';
                    return response;
            }).catch((error)=>{
                const response = {
                    Data: dismissibleMessage,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                return response as IApiResponse<IDismissibleMessage>;
            });

            return dbResponse;
        } else {
            console.error('db not connected');
            return dbFailedResponse;
        }
    },
}

export default DismissibleMessageServiceHybrid;